import { NpeEnvironment } from "raci-react-library-npe";

// <------------------>
//  API Client
// <------------------>
export const ENVIRONMENT = (process.env.REACT_APP_ENVIRONMENT ?? "") as NpeEnvironment;
export const NPE_OAUTH_CLIENT_ID = process.env.REACT_APP_NPE_OAUTH_CLIENT_ID ?? "";
export const NPE_OAUTH_AUTHORITY = process.env.REACT_APP_NPE_OAUTH_AUTHORITY ?? "";
